import { Container, Row } from "reactstrap";
import { BonusUi, SweetAlert } from "../../../constants";
import AutoCloseAlert from "./AutoCloseAlert";
import BasicAlert from "./BasicAlert";
import DangerAlert from "./DangerAlert";
import InfoAlert from "./InfoAlert";
import MovieAlert from "./MovieAlert";
import PikachuAlert from "./PikachuAlert";
import QuestionAlert from "./QuestionAlert";
import SuccessMessage from "./SuccessMessage";
import TitleWithText from "./TitleWithText";
import UserNameAlert from "./UserNameAlert";
import WarningAlert from "./WarningAlert";
import WarningMode from "./WarningMode";
import Breadcrumbs from "../../../coreComponents/breadcrumbs";

const SweetAlertContainer = () => {
  return (
    <>
      <Breadcrumbs mainTitle={SweetAlert} parent={BonusUi} />
      <Container fluid>
        <Row>
          <BasicAlert />
          <TitleWithText />
          <InfoAlert />
          <WarningAlert />
          <PikachuAlert />
          <QuestionAlert />
          <UserNameAlert />
          <SuccessMessage />
          <DangerAlert />
          <WarningMode />
          <AutoCloseAlert />
          <MovieAlert />
        </Row>
      </Container>
    </>
  );
};
export default SweetAlertContainer;
